import react from "react";

const Images =(props)=>{
    return(<img src={props.imgsrc} alt="test" className="card-img-top"/>)
}
export default Images;